import { render } from "./ConfigurationMenuName.vue?vue&type=template&id=ad72a376"
import script from "./ConfigurationMenuName.vue?vue&type=script&lang=js"
export * from "./ConfigurationMenuName.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ConfigurationMenuName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad72a376"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad72a376', __exports__)) {
    console.log('reload')
    api.reload('ad72a376', __exports__)
  }
  
  module.hot.accept("./ConfigurationMenuName.vue?vue&type=template&id=ad72a376", () => {
    console.log('re-render')
    api.rerender('ad72a376', render)
  })

}


export default __exports__